import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {EventWizardErrorInfoProps} from './event-wizard-error-info.types';

export function EventWizardErrorInfo({text, className}: EventWizardErrorInfoProps): ReactElement<any> {
  return (
    <div className={`${className} flex-row-align-center spacing-m-b-2`}>
      <Icon className="content-danger spacing-m-r-1" icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_16} />
      <Text className="content-danger" val={text} size={TextSize.XXSMALL} />
    </div>
  );
}
